import { zfTranslations } from "./zf_translations";
import { zfUtils } from "./zf_utils";
export class zfccd {
    static addBtn(config) {
        if (zfccd.valid()) {
            var btn = $('<div class="zfcui-btn-wrapper"><a><div class="zfcui-btn ' +
                (config.hasOwnProperty("class") ? config.class : "") +
                '"><span class="zfcui-btn-label zfcui-btn-label-wi" tabindex="0"><span>' +
                (config.hasOwnProperty("trans")
                    ? zfTranslations.get(config.trans)
                    : "") +
                "</span></span></div></a></div>");
            zfccd.dialog.append(btn);
            if (config.hasOwnProperty("callback"))
                zfccd.dialog
                    .find(btn)
                    .off("click.zfccd")
                    .on("click.zfccd", function () {
                    config.callback($(this));
                });
            zfccd.dialog.find(btn).show();
        }
    }
    static addDefaultBtns() {
        if (zfccd.valid()) {
            zfccd.addBtn({
                trans: "ok",
                callback: function () {
                    zfccd.close();
                    return true;
                },
            });
        }
    }
    static removeBtns() {
        if (zfccd.valid())
            zfccd.dialog.find("> .zfcui-btn-wrapper").remove();
    }
    static valid() {
        if (zfccd.dialog != undefined && zfccd.dialog.length > 0)
            return true;
        return false;
    }
    static close() {
        if (zfccd.valid())
            zfccd.dialog.hide();
    }
    static updateTitle(value) {
        if (zfccd.valid())
            if (value == null)
                zfccd.dialog.find(".zfccd-title").remove();
            else {
                if (zfccd.dialog.find(".zfccd-title").length == 0)
                    zfccd.dialog.append('<div class="zfccd-title"></div>');
                zfccd.dialog.find(".zfccd-title").html(value);
                zfccd.dialog.find(".zfccd-title").show();
            }
    }
    static updateContent(value) {
        if (zfccd.valid())
            if (value == null)
                zfccd.dialog.find(".zfccd-content").remove();
            else {
                if (zfccd.dialog.find(".zfccd-content").length == 0)
                    zfccd.dialog.append('<div class="zfccd-content"></div>');
                zfccd.dialog.find(".zfccd-content").html(zfUtils.decodeHtml(value));
                zfccd.dialog.find(".zfccd-content").show();
            }
    }
    static showDialog(config) {
        zfccd.dialog = $("#zfccd-confirmation-dialog");
        if (zfccd.valid())
            zfccd.dialog.remove();
        if (!zfccd.valid()) {
            if (!config.hasOwnProperty("dialogSize"))
                config["dialogSize"] = "medium";
            $(".body-wrapper").append('<div id="zfccd-confirmation-dialog" class="' +
                "zfccd-" +
                config.dialogSize +
                '"></div>');
            zfccd.dialog = $("#zfccd-confirmation-dialog");
            if (config.hasOwnProperty("title"))
                zfccd.updateTitle(config.title);
            if (config.hasOwnProperty("content"))
                zfccd.updateTitle(config.content);
            if (!config.hasOwnProperty("buttons") || config.buttons.length == 0)
                zfccd.addDefaultBtns();
            else
                config.buttons.forEach(function (btn) {
                    zfccd.addBtn(btn);
                });
        }
        zfccd.dialog.show();
    }
}
zfccd.dialog = undefined;
